import React from 'react';
import '../dashboard.scss';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { faChevronRight, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WelcomeImg from '../../../assets/images/WelcomeImg.png';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { selectCurrentUserData } from '../../../features/authentication/authSlice';
import { useGetProfileCompletionPercentageQuery } from '../../../features/componentEndpoints/profileInformationEndpoints';

const DashboardHeader = () => {
  const navigate = useNavigate();
  const user = useSelector(selectCurrentUserData);
  const [date, setDate] = React.useState(new Date());
  const [expand, setExpand] = React.useState(false);
  const [percentage, setPercentage] = React.useState(0);
  const { data: profileCompletionPercentageData } = useGetProfileCompletionPercentageQuery();

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDate(new Date());
    }, 24 * 60 * 60 * 1000); // update date every day

    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => {
    if (profileCompletionPercentageData != null) {
      setPercentage(profileCompletionPercentageData);
    }
  }, [profileCompletionPercentageData]);

  const completeProfileHandler = () => {
    navigate('Profile');
  };
  return (
    <div className="dashboard_header_container py-3 px-4 mb-4">
      {!expand && (
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="mb-0">
            Welcome back, <strong>{user?.FirstName + ' ' + user?.LastName}!</strong>
          </h2>

          <div className="complete_profile_box d-flex justify-content-end  align-items-center">
            <p className="mb-0 me-3">{percentage < 100 ? 'Complete Your Profile' : 'Edit Your Profile'}</p>
            <CircularProgressbar
              value={percentage}
              text={`${percentage}%`}
              strokeWidth={12}
              styles={buildStyles({
                pathColor: (percentage <= 30 ?  '#FB5F5F' : percentage <= 75 ? '#f7931e' : '#52C9A5'),
                textColor: '#525252',
                trailColor: '#d6d6d6'
              })}
            />
            <div className="ms-3 ps-3 expand-icon">
              <span
                style={{
                  transform: `${expand ? 'rotate(90deg)' : 'rotate(0deg)'}`
                }}
                onClick={() => setExpand(!expand)}
                className="d-block">
                <FontAwesomeIcon icon={faChevronRight} />
              </span>
            </div>
          </div>
        </div>
      )}
      {expand && (
        <div className="row dashboard-header-open align-items-center">
          <div className="col-lg-4 dashboard-header-box-1">
            <h6 className="mb-2">
              <span className="d-inline-flex align-items-center bg-white rounded-pill">
                <FontAwesomeIcon icon={faCalendarDays} />
                {date.toLocaleDateString('en-GB', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}
              </span>
            </h6>
            <h2 className="mb-2">
              Welcome back, <strong>{user.FirstName + ' ' + user.LastName}!</strong>
            </h2>
            <p className="mb-0">
              We provide a wide range of content-specific learning support at every grade level – from core subjects to electives.
            </p>
          </div>
          <div className="col-lg-8 d-flex align-items-center">
            <div className="dashboard-header-box-2 d-flex">
              <CircularProgressbar
                value={percentage}
                text={`${percentage}%`}
                strokeWidth={12}
                styles={buildStyles({
                  pathColor: (percentage <= 30 ?  '#FB5F5F' : percentage <= 75 ? '#f7931e' : '#52C9A5'),
                  textColor: '#525252',
                  trailColor: '#d6d6d6'
                })}
              />
              <div className="ms-4">
                <h4 className="mb-2">{percentage < 100 ? 'Complete Your Profile' : 'Edit Your Profile'}</h4>
                <p className="mb-2">{percentage < 100 ? 'You\'re steps away from getting the best Castle experience.' : 'Make your Castle experience even better by keeping your profile updated'}</p>
                <button onClick={completeProfileHandler} className="btn teritary-btn">
                  {percentage < 100 ? 'Complete Now' : 'Edit Profile'}
                </button>  
              </div>
            </div>
            <div className="ms-auto flex-shrink-0 d-flex">
              <img src={WelcomeImg} className="img-fluid" alt="" />
              <div className="ms-3 ps-3 expand-icon">
                <span
                  style={{
                    transform: `${expand ? 'rotate(90deg)' : 'rotate(0deg)'}`
                  }}
                  onClick={() => setExpand(!expand)}
                  className="d-block">
                  <FontAwesomeIcon icon={faChevronRight} />
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
